import { Actions } from './Actions'
import { AssetCollection, Asset } from '../assets/Asset'
import { AttachmentCollection, Attachment } from '../Attachment';
import { build_findings_menu_json } from '../ui/menu/FindingsMenu'
import { CategoryCollection } from '../Categories'
import { Configuration } from '../Configuration';
import { Drawing } from '../drawings/Drawing'
import { DrawingsCollection } from '../drawings/DrawingsCollection'
import { DrawingsReducer } from '../drawings/DrawingsReducers'
import { exists } from '../utils';
import { Finding, FindingCollection } from '../Findings'
import { Id_floor, Id_workorder, Id_building, Id_drawing, Id_location, Id_category } from '../api/Identifiers'
import { Keys, StateValues } from './Datastore'
import { Point } from '../Point'
import { Rectangle } from '../Rectangle'
import { BuildingCollection, Building } from '../Building'
import { State } from './State'
import { Translate } from '../Geometry'
import { Workorder } from '../workorders/Workorder'
import { WorkordersCollection } from '../workorders/WorkordersCollection'
import {get_a_drawing_from_floor, get_a_drawing_from_building, get_default_drawing} from '../DrawingHistory'
import { CmsApi } from '../cms_api';

// AWH TODO: write a unit test for this!

function rebuild_assets(old_state: State, new_state: State): State {

    // If it is early in the load process, the id_floor may not exist yet.
    if (new_state.id_floor) {
        if (new_state.did_any_change(old_state, [Keys.DATA_ASSETS, Keys.DRAWING_P1P2])) {
            //            console.error(new_state.did_any_change(old_state, [Keys.DATA_ASSETS]))
            //            console.error(new_state.did_any_change(old_state, [Keys.DRAWING_P1P2]))
            // translate the assets for the new id_floor, or id_location
            new_state.assets.translate_assets(new_state.drawing_p1p2, new_state.id_floor, new_state.drawing_p0, new_state.nudge_overlapping);
            // build the new data_assets from the current floor
            let data_assets: any = new_state.assets.sorted_by_floor_json();
            new_state = new_state.set_obj(Keys.DATA_ASSETS, data_assets);
        }
    }
    return new_state;
}



function rebuild_findings_menu(old_state: State, new_state: State): State {
    // redraw the assets menu
    if (new_state.id_floor){
        if (new_state.did_any_change(old_state, [Keys.ID_BUILDING, Keys.DRAWING_P1P2,
        Keys.ID_FLOOR,
        Keys.DATA_FINDINGS,
        Keys.KEY_DATA_CATEGORIES])) {
            new_state.findings.translate_findings(new_state.drawing_p1p2, new_state.id_floor, new_state.drawing_p0, new_state.nudge_overlapping);
            let filtered_findings: Finding[] = new_state.findings.get_findings_on_floor(new_state.id_floor).findings;
            let findings_menu: any[] = build_findings_menu_json(FindingCollection.wrap(filtered_findings), new_state.categories);
            new_state = new_state.set_array(Keys.MENU_FINDINGS_CONTENT, findings_menu)
    }
    }
    return new_state;
}



function action_clear_attachments_data(old_state: State): State {
    let new_state: State = old_state.set_array(Keys.KEY_DOWNLOADED_ATTACHMENT_FLOORS, [])
    // the caller will re-fetch the attachments data.
    return new_state.set_attachments(AttachmentCollection.empty()); // new_state = reducer_apply_action(new_state, ACTION_CLEAR_ATTACHMENTS_DATA, null);                return new_state

}

// pass in the old state, array of raw assets, and retuns a state that has been updated to contain
function action_set_asset_data(old_state: State, raw_assets: any[]): State {
    let assets: Asset[] = AssetCollection.build_from_raw(raw_assets);
    // console.log(assets);
    assets = assets.filter((asset: Asset) => asset.is_valid()); // filter out bad assets
    let asset_collection: AssetCollection = old_state.assets;
    asset_collection.add_assets(assets);
    return old_state.set_assets(asset_collection);
}

function action_set_findings_data(old_state: State, raw_findings: any[]): State {

    let new_findings: Finding[] = FindingCollection.build_from_raw(raw_findings);
    let fc: FindingCollection = old_state.findings;
    fc.add_findings(new_findings);
    return old_state.set_findings(fc);
}
function action_set_workorders_data(old_state: State, raw_workorders: any[]): State {

    let new_state: State = old_state;
    let new_workorders: WorkordersCollection = WorkordersCollection.build_from_raw(raw_workorders);
    //workorders.workorders.filter((workorder:Workorder)=>workorder.is_valid());
    let wc: WorkordersCollection = new_state.workorders;
    wc.add_raw(raw_workorders);

    // build the floor_building_obj.
    let floor_building_obj: any = {};
    let data_floorplans: DrawingsCollection = new_state.all_drawings;//.get_array(Keys.KEY_DATA_FLOORPLANS, []);
    data_floorplans.drawings.forEach((floorplan: any) => {
        floor_building_obj[floorplan.id_floor] = floorplan.id_building;
    });

    // need to build the building_wo_count object
    let work_order_count: any = {};
    wc.workorders.forEach((workorder: Workorder) => {
        let id_floor: any = workorder.id_floor.value;
        let building: any = "";

        for (var floor_id in floor_building_obj) {
            if (floor_id == id_floor) {
                building = floor_building_obj[floor_id];
                break;
            }
        }

        let found: boolean = false;
        for (var b in work_order_count) {
            if (b == building) {
                let count: number = work_order_count[b];
                count++;
                work_order_count[b] = count;
                found = true;
                break;
            }
        }
        if (!found) {
            work_order_count[building] = 1;
        }

    });
    new_state = new_state.set_building_wo_count(work_order_count);
    new_state = new_state.set_workorders(wc);
    return new_state;
}



function action_set_floor_only(old_state: State, id_floor: Id_floor): State {
    let drawing: Drawing = null;

    if (exists(id_floor)) {
        drawing = get_a_drawing_from_floor(id_floor, old_state);
    }

    if (!exists(drawing)){
        drawing = get_default_drawing(old_state);
    }

    if (exists(drawing)) {
        return old_state.set_drawing(drawing);
    }
    return old_state;

}
function action_set_floor(old_state: State, action: string, data: any): State {  // awh todo - this funciton may not be needed. floor should only be set from a "set_id_floor" action.

    /*
    expected action.data ==
    {
    id_drawing : "9b5b8852-f985-445a-ba00-7df642edb43a",
    id_floor         : "81097"
    }
    */

    let id_floor = data.id_floor
    let id_drawing = data.id_drawing
    let drawing: Drawing = null;
    let drawings: DrawingsCollection = old_state.all_displayable_drawings;

    if (exists(id_drawing)) {
        drawing = drawings.get_drawing_from_drawing_id(Id_drawing.wrap(id_drawing));
    }
    else if (exists(id_floor)) {
        drawing = get_a_drawing_from_floor(id_floor, old_state);
    }

    if (!exists(drawing)){
        drawing = get_default_drawing(old_state);
    }

    if (exists(drawing)) {
        return old_state.set_drawing(drawing);
    }
    return old_state;
}

function action_set_attachments_data(old_state: State, data: any): State {
    let new_state: State = old_state;
    let new_attachments: AttachmentCollection = AttachmentCollection.build_from_raw(data);
    let old_attachments: AttachmentCollection = new_state.attachments;
    let all_attachments: AttachmentCollection = old_attachments.extend(new_attachments);

    let json_attachments: any = {};
    all_attachments.attachments.forEach((attachment: Attachment) => {
        let id_floor = attachment.id_location.toString();
        if (!(id_floor in json_attachments)) {
            json_attachments[id_floor] = {}
        }
        json_attachments[id_floor][attachment.id.toString()] = attachment.toJson();
    });
    return new_state.set_attachments(all_attachments).set_obj(Keys.KEY_DATA_ALL_ATTACHMENTS, json_attachments);
}

function action_set_sitemap_url(old_state: State, action: string, data: any): State {

    /*
     expected action.data ==
     {
     id_drawing : "9b5b8852-f985-445a-ba00-7df642edb43a",
     id_floor         : "81097"
     }
     */

    let id_floor = data.id_floor
    let id_drawing = data.id_drawing
    let tiles_url = data.tiles_url
    let id_building = data.id_building
    let drawing: Drawing = null;
    let drawings: DrawingsCollection = old_state.all_displayable_drawings;
    // let drawings_history: Id_drawing[] = old_state.drawing_history;

    if (exists(id_drawing)) {
        drawing = drawings.get_drawing_from_drawing_id(Id_drawing.wrap(id_drawing));
    }
    else if (exists(id_floor)) {
        drawing = get_a_drawing_from_floor(id_floor, old_state);
    }
    if(!exists(drawing)){
        drawing = old_state.all_displayable_drawings.get_all_in_floor(id_floor).drawings[0]
    }
    if (!exists(drawing)){
        drawing = get_default_drawing(old_state);
    }

    if (exists(drawing)) {
        return old_state.set_drawing(drawing);
    }
    return old_state;
}

function action_set_add_attachment_state(old_state: State, data: any): State {
    let new_state: State = old_state;
    let state_value = data;
    if (data === undefined) {
        console.error("ACTION_SET_ADD_ATTACHMENT_STATE SHOULD NEVER BE UNDEFINED")
    }
    if (data === null) {
        console.error("ACTION_SET_ADD_ATTACHMENT_STATE SHOULD NEVER BE UNDEFINED")
    }
    if (state_value === true) {
        state_value = StateValues.STATE_CREATING_ATTACHMENT_GETTING_COORD;// VALUE_CREATING_ATTACHMENT_GETTING_COORD;
    }
    if (state_value === false) {
        state_value = StateValues.STATE_CREATING_ATTACHMENT_VOID;//   VALUE_CREATING_ATTACHMENT_VOID;
        console.debug('ACTION_SET_ADD_ATTACHMENT_STATE === false')
    }
    if (state_value === StateValues.STATE_CREATING_ATTACHMENT_VOID) {
        // we're leaving the add attachment state
        new_state = new_state.set_string(Keys.KEY_MOUSE_CURSOR, "auto")
        // reset the attachment object
        new_state = new_state.set_obj(Keys.KEY_ADD_ATTACHMENT_OBJECT, {})
    }
    else if (state_value === StateValues.STATE_CREATING_ATTACHMENT_GETTING_COORD) {
        // we cannot be in both the new asset and new workorder states simultaneously.
        // if we're currently in the set work order mode, exit it.
        //      imm_new_state=imm_new_state.set(KEY_STATE_ADD_WORKORDER, false)
        //      imm_new_state=imm_new_state.set(KEY_STATE_ADD_ASSET, false)
        //      imm_new_state=imm_new_state.set(KEY_MOUSE_CURSOR, "crosshair")
        // if we are entering an add attachment state, reset the attachment object
        //      imm_new_state=setJSObject(imm_new_state, KEY_ADD_ATTACHMENT_OBJECT, {})
    }
    else if (state_value === StateValues.STATE_CREATING_ATTACHMENT_GETTING_FILE) {
        new_state = new_state.set_string(Keys.KEY_MOUSE_CURSOR, "auto")
        // do additional changes to the state
    }
    else if (state_value === StateValues.STATE_CREATING_ATTACHMENT_API_BUSY) {//}  VALUE_CREATING_ATTACHMENT_API_CREATING_ATTACHMENT) {
        new_state = new_state.set_string(Keys.KEY_MOUSE_CURSOR, "auto")
        // do additional changes to the state
    }

    new_state = new_state.set_string(Keys.STATE_CREATING_ATTACHMENT, state_value)
    return new_state
}

function action_set_sitemap_data(old_state: State, action: string, data: any): State {

    let state: State = old_state;
    let site_drawings: DrawingsCollection = DrawingsCollection.build_from_raw_sitemap(data)
    let drawings: DrawingsCollection = state.all_drawings;
    drawings.add_collection(site_drawings)
    state = state.set_drawings_data(drawings);

    return state;
}

function action_set_drawings_info_data(old_state: State, data: any): State {

    let state: State = old_state;

    state = state.set_drawings_info_data(data);
    return state;
}

function action_set_add_findings_state(old_state: State, in_set_finding_mode: boolean): State {
    let new_state: State = old_state;
    if (in_set_finding_mode) {
        // we cannot be in both the new asset and new workorder states simultaneously.
        // if we're currently in the set work order mode, exit it.
        new_state = new_state.set_boolean(Keys.STATE_CREATING_ASSET, false);
        new_state = new_state.set_boolean(Keys.STATE_CREATING_WORKORDER, false);
        new_state = new_state.set_string(Keys.STATE_CREATING_ATTACHMENT, StateValues.STATE_CREATING_ATTACHMENT_VOID);
        new_state = new_state.set_mouse_crosshair(true);
    }
    else {
        new_state = new_state.set_mouse_crosshair(false);
    }
    new_state = new_state.set_boolean(Keys.STATE_CREATING_FINDING, in_set_finding_mode);
    return new_state;
}

function action_set_building(old_state: State, id_building: Id_building): State {

    let new_state: State = old_state;
    if (exists(id_building)){
        let drawing: Drawing = get_a_drawing_from_building(id_building, old_state);
        if (!exists(drawing)){
            drawing = get_default_drawing(old_state);
        }
        if (exists(drawing)) {
            new_state = new_state.set_drawing(drawing);
        }
        new_state = new_state.set_boolean(Keys.KEY_MENU_PUSHPIN_SELECTED, false);
        new_state = new_state.set_pushpin_coord(null)
    }
    return new_state;
}


function action_set_buildings_data(old_state: State, data: any): State {
    let buildings: BuildingCollection = BuildingCollection.build_from_raw(data);
    let menu_buildings_show: boolean = true;
    if (buildings.length < 2) {
        menu_buildings_show = false; // if there is only one building availible, don't show the building menu
    }
    // let id_building: Id_building = old_state.id_building;

    // // We must confirm that the id_building in the state is in the set of data we received. Otherwise it is invalid.
    // if (buildings.length > 0) {
    //     let first_building_in_the_data: Id_building = buildings.buildings[0].id_building

    //     let current_id_building_is_in_the_list: boolean = false;
    //     if (id_building) {
    //         buildings.buildings.forEach((building: Building) => {
    //             if (id_building === building.id_building) {
    //                 id_building=null;
    //             }
    //         })
    //     }
    //     // special case:
    //     // if there is no building already selected,
    //     // then set the selected building to be the first building in this list
    //     if (!id_building) {
    //         id_building = first_building_in_the_data;
    //     }
    // }
    return old_state.set_buildings(buildings).set_menu_buildings_show(menu_buildings_show);
}



export class Reducer {

    public static reducer_2(old_state: State, new_state: State): State {

        if (new_state.did_any_change(old_state, [Keys.ID_DRAWING,
        Keys.HASH_BUILDINGS_DATA,
        Keys.HASH_DATA_FLOORPLANS,
        Keys.HASH_DRAWINGS_INFO_DATA])) {
            if (new_state.all_displayable_drawings.length > 0) {
                let drawing: Drawing = new_state.all_displayable_drawings.get_drawing_from_drawing_id(new_state.id_drawing);
                if (!exists(drawing)) {
                    // get a default drawing
                    drawing = get_default_drawing(new_state)
                    if (exists(drawing)) {
                        new_state = new_state.set_drawing(drawing);
                    }
                }
            }
        }
        // rebuild intermediate data structures
        new_state = rebuild_assets(old_state, new_state);

        // rebuild menus
        //        new_state = rebuild_assets_menu(old_state, new_state);
        // rebuild menus
        new_state = rebuild_findings_menu(old_state, new_state);

        // rebuild maps
        if (new_state.did_any_change(old_state, [Keys.MENU_ASSETS_SELECTED])) {
            let asset_categories: any[] = new_state.get_array(Keys.MENU_ASSETS_SELECTED, []);
            asset_categories.forEach((val) => {
                // awh todo add code here to build a state object that holds info about all features plotted on the map

            })
        }

        if (new_state.did_any_change(old_state, [Keys.DRAWING_P1P2, Keys.DATA_ASSETS, Keys.DATA_WORKORDERS])) {
            new_state.workorders.translate_workorders(new_state.drawing_p1p2, new_state.id_floor, new_state.drawing_p0, Configuration.is_decluster_enabled)
            new_state.assets.translate_assets(new_state.drawing_p1p2, new_state.id_floor, new_state.drawing_p0, Configuration.is_decluster_enabled)
            new_state.findings.translate_findings(new_state.drawing_p1p2, new_state.id_floor, new_state.drawing_p0, Configuration.is_decluster_enabled);
        }


        if (new_state.did_change(old_state, Keys.BUILDING_P1P2)) {

            if (new_state.building_p1p2) {
                let old_pushpin: Point = new_state.pushpin_coord;
                let old_p1p2: Rectangle = old_state.building_p1p2;
                let new_p1p2: Rectangle = new_state.building_p1p2;
                if (old_pushpin) {
                    // if old_pushpin is null, no old_pushpin to move around
                    let new_pushpin: Point = Translate(old_pushpin, old_p1p2, new_p1p2);
                    new_state = new_state.set_pushpin_coord(new_pushpin);
                }
            }
            else if (old_state.building_p1p2){
                let old_pushpin: Point = new_state.pushpin_coord;
                if (exists(old_pushpin)){
                    console.debug("old state has building p1p2 but new does not? ")
                    // new_state = new_state.set_pushpin_coord(null);
                    // new_state = new_state.set_boolean(Keys.KEY_MENU_PUSHPIN_SELECTED, false);
                }

            }

            //console.log()
        }


        return new_state;
    }

    // attachment API states
    public static reducer(old_state: State, action: string, data: any): State {
        // run simple reducer
        let new_state: State = Reducer.simple_reducer(old_state, action, data);
        return Reducer.reducer_2(old_state, new_state);
    }

    public static simple_reducer(old_state: State, action: string, data: any): State {

        switch (action) {
            case Actions.ACTION_API_UPDATEATTACHMENT_SUCCESS:
                {
                    let temp = old_state;
                    temp = temp.set_boolean(Keys.KEY_STATE_API_UPDATEATTACHMENT, false);
                    let updated_attachments: any[] = [data]; // the result should be an array of attachemnt objects
                    return action_set_attachments_data(temp, updated_attachments);
                }
            case Actions.ACTION_API_UPDATEATTACHMENT_FAIL:
                {
                    return old_state.set_boolean(Keys.KEY_STATE_API_UPDATEATTACHMENT, false);
                }
            case Actions.ACTION_API_UPDATEATTACHMENT_START:
                {
                    return old_state.set_boolean(Keys.KEY_STATE_API_UPDATEATTACHMENT, true);
                }
            case Actions.ACTION_API_DELETEATTACHMENT_START:
                {
                    return old_state.set_boolean(Keys.KEY_STATE_API_DELETEATTACHMENT, true);
                }
            case Actions.ACTION_API_DELETEATTACHMENT_FAIL:
                {
                    return old_state.set_boolean(Keys.KEY_STATE_API_DELETEATTACHMENT, false);
                }




            case Actions.ACTION_CLEAR_FINDINGS_DATA: {
                return old_state.set_array(Keys.DOWNLOADED_FINDINGS_FLOORS, []).set_obj(Keys.DATA_FINDINGS, {})
            }
            case Actions.SET_KEY_BOOLEAN: {
                // expected data: [key_str, bool]
                if (data) {
                    let key: string = data[0]
                    let val: boolean = data[1]
                    return old_state.set_boolean(key, val);
                }
            }
            case Actions.SET_KEY_STRING: {
                let key: string = null;
                let val: string = null;

                if (data) {
                    key = data[0]
                    val = data[1]
                }
                if (!key) {
                    console.error("called SET_KEY_STRING with no key.")
                    return old_state;
                }
                if (!val) {
                    return old_state.clear(key);
                }
                return old_state.set_string(key, val);

            }
            case Actions.ACTION_SET_SITEMAP_URL: {
                if (data === null) {
                    return old_state.set_string(Keys.SITEMAP_URL, null);//  Reducer.action_api_deleteattachment_start(old_state);
                }
                return action_set_sitemap_url(old_state, action, data);
            }

            case Actions.ACTION_SET_ATTACHMENTS_DATA: {
                // take raw attachments data, clean it up, verify that all necessary fields exist, and save it to the state
                return action_set_attachments_data(old_state, data)
            }

            case Actions.ACTION_API_DELETEATTACHMENT_START: {
                return Reducer.action_api_deleteattachment_start(old_state);
            }

            case Actions.ACTION_UI_CREATEATTACHMENT_GET_FILE_START: {
                return old_state.set_boolean(Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_FILE, true);
            }

            case Actions.ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP: {
                return old_state.set_boolean(Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_FILE, false);
            }

            case Actions.ACTION_UI_CREATEATTACHMENT_GET_LINK_START: {
                return old_state.set_boolean(Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_LINK, true);
            }

            case Actions.ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP: {
                return old_state.set_boolean(Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_LINK, false);
            }

            case Actions.ACTION_CLEAR_ATTACHMENTS_DATA: {
                return action_clear_attachments_data(old_state);
            }

            case Actions.ACTION_API_DELETEATTACHMENT_SUCCESS: {
                let new_state: State = old_state;
                new_state = new_state.set_boolean(Keys.KEY_STATE_API_DELETEATTACHMENT, false);
                // clear out the current attachments data
                new_state = action_clear_attachments_data(new_state);
                // mark the attachments layer as selected
                new_state = new_state.set_boolean(Keys.KEY_MENU_ATTACHMENTS_SELECTED, true);
                return new_state;
            }

            case Actions.ACTION_API_DELETEATTACHMENT_FAIL: {
                return Reducer.action_api_deleteattachment_stop(old_state);
            }

            case Actions.ACTION_CLEAR_WORKORDERS_DATA: {
                return old_state.set_workorders(WorkordersCollection.empty_collection);
            }

            case Actions.ACTION_SET_FINDINGS_DATA: {
                let raw_findings: any = data;
                return action_set_findings_data(old_state, raw_findings);
            }

            case Actions.SET_WORKORDERS_DATA: {
                let raw_workorders: any = (<any>data).workOrders;
                return action_set_workorders_data(old_state, raw_workorders);
            }

            case Actions.SET_WORKORDERS_QUERY:{
                let workorders_query = data;
                let new_state: State = old_state.set_workorders_query(workorders_query)
                // remove the workorders from the state.
                new_state=new_state.set_workorders(WorkordersCollection.empty_collection);
                CmsApi.api_get_workorders(workorders_query)//TODO shouldn't be done inside reducer
                return new_state;
            }

            case Actions.ACTION_UPDATE_WORKORDERS: {
                let raw_workorders: any[] = data
                return action_set_workorders_data(old_state, raw_workorders);
            }

            case Actions.SET_CATEGORY_DATA: {
                let raw_categories: any = (<any>data);
                return old_state.set_categories(CategoryCollection.build_from_raw(raw_categories));
            }

            case Actions.ACTION_SET_BUILD_ID: {
                return old_state.set_build_id(<string>data);
            }

            case Actions.ACTION_SET_BUILDINGS_DATA: {
                return action_set_buildings_data(old_state, data);
            }

            case Actions.ACTION_SET_FLOORPLAN_DATA: {
                return DrawingsReducer.Action_set_floorplan_data(old_state, data);
            }

            case Actions.ACTION_SET_ID_BUILDING: {
                return action_set_building(old_state, Id_building.wrap(data));
            }

            case Actions.ACTION_SET_ASSET_DATA: { return action_set_asset_data(old_state, data); }

            case Actions.ACTION_UPDATE_ASSETS: { return action_set_asset_data(old_state, data); }

            case Actions.ACTION_UPDATE_FINDINGS: {
                let raw_findings: any = data;
                return action_set_findings_data(old_state, raw_findings);
            }

            case Actions.ACTION_SET_FLOOR: {
                return action_set_floor(old_state, action, data);
            }

            case Actions.ACTION_SET_FLOOR_ONLY: {
                let id_floor: Id_floor = data;
                return action_set_floor_only(old_state, id_floor);
            }

            case Actions.SET_ASSETS_SELECTED: {
                return old_state.set_menu_asset_categories_selected(<Id_category[]>data);
            }
            case Actions.SET_FINDINGS_SELECTED: {
                return old_state.set_selected_findings_categories(<Id_category[]>data);
            }
            case Actions.SET_ADD_FINDINGS_STATE:
                return action_set_add_findings_state(old_state, (data === true));

            case Actions.ACTION_SET_MENU_ATTACHMENTS_SELECTED: {
                return old_state.set_boolean(Keys.KEY_MENU_ATTACHMENTS_SELECTED, (data === true));
            }

            case Actions.ACTION_SET_MENU_PUSHPIN_SELECTED: {
                let new_state: State = old_state.set_boolean(Keys.KEY_MENU_PUSHPIN_SELECTED, data);
                new_state = old_state.set_array(Keys.KEY_MENU_PUSHPIN_SELECTED, data);
                return new_state;
            }
            case Actions.ACTION_SET_PUSHPIN_COORD: {
                if (data) {
                    let p: Point = Point.build_from_array(data);
                    let new_state: State = old_state.set_pushpin_coord(p);
                    return new_state;
                }
                console.error("Null coordinates set to pushpin");
                return old_state;
            }
            case Actions.ACTION_REMOVE_PUSHPIN_COORD: {
                let new_state: State = old_state.set_pushpin_coord(null);
                return new_state;
            }
            case Actions.ACTION_SET_SITEMAP_DATA: {
                return action_set_sitemap_data(old_state, action, data);
            }
            case Actions.ACTION_SET_DRAWINGS_INFO_DATA: {
                return action_set_drawings_info_data(old_state, data);
            }
            case Actions.ACTION_SET_ADD_ATTACHMENT_STATE: {
                return action_set_add_attachment_state(old_state, data);
            }
            case Actions.SET_MENU_WORKORDERS_SELECTED: {
                return old_state.set_array(Keys.MENU_WORKORDERS_SELECTED, data);
            }
            case Actions.ACTION_API_CREATEATTACHMENT_SUCCESS:
                {
                    let new_state: State = old_state;
                    new_state = new_state.set_boolean(Keys.KEY_STATE_API_CREATEATTACHMENT, false);
                    new_state = new_state.set_boolean(Keys.KEY_MENU_ATTACHMENTS_SELECTED, true);
                    new_state = new_state.set_obj(Keys.KEY_ADD_ATTACHMENT_OBJECT, {});
                    new_state = new_state.set_obj(Keys.STATE_CREATING_ATTACHMENT, StateValues.STATE_CREATING_ATTACHMENT_VOID);
                    // mark the attachments layer as selected  
                    // new_state = setJSBool(new_state, KEY_STATE_API_CREATEATTACHMENT, false);
                    // new_state = setJSBool(new_state, KEY_MENU_ATTACHMENTS_SELECTED, true);
                    // new_state = setJSObject(new_state, KEY_ADD_ATTACHMENT_OBJECT, {})
                    // new_state = setJSObject(new_state, KEY_STATE_CREATING_ATTACHMENT, VALUE_CREATING_ATTACHMENT_VOID)
                    return new_state;
                }
            case Actions.ACTION_SET_FETCHING_CMSVIEW_USER_CONFIGURATION:
                {
                    let new_state: State = old_state;
                    return new_state;
                }
            case Actions.ACTION_SET_ENABLED_ALLOW_3D_LINK_CREATE: {
                let allow_3d_link: boolean = data
                if (allow_3d_link) {
                    allow_3d_link = true;
                }
                else {
                    allow_3d_link = false;
                }
                return old_state.set_allow_3D_link_create(allow_3d_link);
            }

            case Actions.ACTION_SET_ENABLED_PHOTO_ATTACHMENT_CREATE: {
                let allow_photo_link: boolean = data
                if (allow_photo_link) {
                    allow_photo_link = true;
                }
                else {
                    allow_photo_link = false;
                }
                return old_state.set_allow_photo_attachment_create(allow_photo_link);
            }
            case Actions.ACTION_SET_TOKEN_IS_BAD: {
                let new_state: State = old_state.set_token_is_bad(data);
                return new_state;
            }
            case Actions.ACTION_ADD_FETCHED_FINDINGS_FLOOR: {
                return add_fetched_findings_floor(old_state, <Id_location>data);
            }
            case Actions.ACTION_SET_FETCHING_FINDINGS: {
                return old_state.set_fetching_findings(<boolean>data);
            }
            case Actions.ACTION_SET_PRINTING_FINDINGS: {
                return old_state.set_printing_findings(<boolean>data);
            }
        }
        console.error(`should not get here. unhandled action ${action}.`);
        return old_state;
    }



    private static action_api_deleteattachment_start(old_state: State): State {
        return null //old_state.set(Keys.KEY_STATE_API_DELETEATTACHMENT, true);
    }
    private static action_api_deleteattachment_stop(old_state: State): State {
        return null//new State(old_state.set(Keys.KEY_STATE_API_DELETEATTACHMENT, false));
    }

}

function add_fetched_findings_floor(old_state: State, id_location: Id_location): State {
    return old_state.set_downloaded_findings_floors(old_state.downloaded_findings_floors.add(id_location));
}






// WEBPACK FOOTER //
// ./src/ts/redux/Reducer.ts